import { Injectable, OnInit } from "@angular/core";
import { LoginService } from '../views/login/login.service';

@Injectable()
export class AuthService implements OnInit {
  cache: Object = null;
  token: String = "";
  constructor(public loginFactory: LoginService) {
    let loginData = JSON.parse(localStorage.getItem("loginData"));
  }

  ngOnInit() { }

  setAuthData(data) {
    if (data) {
      this.cache = data;
      localStorage.setItem("loginData", JSON.stringify(data));
    }
  }

  getLoginDetails() {
    return JSON.parse(localStorage.getItem("loginData"));
  }

  clearAuthData() {
    this.cache = null;
    localStorage.clear();
  }
}
